module.exports = __webpack_public_path__ + "media/images/profile-db328505dadab3ba8d2361e7df9ede45.svg";